import {createFileRoute} from "@tanstack/react-router"
import {Invest} from "@/components/invest/Invest.tsx";
import {PoolId} from "@/redux/poolSlice.ts";

export const Route = createFileRoute("/_mainLayout/revshare-pools/$year/$month/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { year, month } = Route.useParams()
  return (
    <Invest poolId={{ month: parseInt(month), year: parseInt(year) } as PoolId}/>
  );
}
